import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-379d3252"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "export"
}, "Export", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Level 1", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Level 2", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_profit_and_loss_filters = _resolveComponent("profit-and-loss-filters");
  const _component_currency_filter = _resolveComponent("currency-filter");
  const _component_download_icon = _resolveComponent("download-icon");
  const _component_flex_row = _resolveComponent("flex-row");
  const _component_b_button = _resolveComponent("b-button");
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
  const _component_b_dropdown = _resolveComponent("b-dropdown");
  const _component_aggregate_table = _resolveComponent("aggregate-table");
  const _component_omny_ui_layout = _resolveComponent("omny-ui-layout");
  return _openBlock(), _createBlock(_component_omny_ui_layout, {
    class: "profit-and-loss-page",
    loading: $data.aggregateTableLoading,
    "content-padding": "0"
  }, {
    "topbar-contents": _withCtx(() => [_createVNode(_component_flex_row, {
      gap: 16,
      align: "right"
    }, {
      default: _withCtx(() => [_createVNode(_component_profit_and_loss_filters, {
        ref: "filters",
        loading: $data.datePickerLoading
      }, null, 8, ["loading"]), _createVNode(_component_currency_filter, {
        currencies: _ctx.currencies,
        "only-mode": "",
        onApply: $options.handleApplyForCurrencyChange
      }, null, 8, ["currencies", "onApply"]), _createVNode(_component_b_dropdown, {
        class: "export-dropdown",
        offset: "8",
        "no-caret": "",
        strategy: "fixed"
      }, {
        "button-content": _withCtx(() => [_createVNode(_component_b_button, {
          variant: "outline-secondary",
          class: "export-btn",
          loading: $data.exportLoading,
          loadingText: "Exporting P&L Report  "
        }, {
          default: _withCtx(() => [_createVNode(_component_flex_row, {
            gap: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_download_icon), _hoisted_1]),
            _: 1
          })]),
          _: 1
        }, 8, ["loading"])]),
        default: _withCtx(() => [_createVNode(_component_b_dropdown_item, {
          onClick: _cache[0] || (_cache[0] = $event => $options.handleExport($data.PL_EXPORT_LEVEL.LEVEL_1))
        }, {
          default: _withCtx(() => [_createTextVNode("Only "), _hoisted_2, _createTextVNode(" records")]),
          _: 1
        }), _createVNode(_component_b_dropdown_item, {
          onClick: _cache[1] || (_cache[1] = $event => $options.handleExport($data.PL_EXPORT_LEVEL.LEVEL_2))
        }, {
          default: _withCtx(() => [_createTextVNode("Upto "), _hoisted_3, _createTextVNode(" records")]),
          _: 1
        }), _createVNode(_component_b_dropdown_item, {
          onClick: _cache[2] || (_cache[2] = $event => $options.handleExport($data.PL_EXPORT_LEVEL.DEFAULT))
        }, {
          default: _withCtx(() => [_createTextVNode("All levels")]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })]),
    default: _withCtx(() => [_createVNode(_component_aggregate_table, {
      loading: $data.aggregateTableLoading,
      items: $options.getAggregateTableItems,
      colGroups: $options.getColGroups,
      minMax: _ctx.aggregateTable.minMax
    }, null, 8, ["loading", "items", "colGroups", "minMax"])]),
    _: 1
  }, 8, ["loading"]);
}